import { Injectable } from '@angular/core';
import { InlineAddConfig } from './inline-add-panel.component';

@Injectable({
  providedIn: 'root'
})
export class StockGroupAddConfigService {
  getStockGroupConfig(): InlineAddConfig {
    return {
      modelType: 'stockgroup',
      title: 'Stock Group',
      apiEndpoint: 'api/stockgroups/create',
      hiddenData: {
        isActive: true,
      },
      fields: [
        {
          name: 'code',
          label: 'Stock Group Code',
          type: 'text',
          required: true,
          isInstantData: true,
          maxLength: 50,
          placeholder: 'Auto-generated by system',
          size: 'half'
        },
        {
          name: 'name',
          label: 'Name',
          type: 'text',
          required: true,
          maxLength: 250,
          placeholder: 'Enter group name',
          size: 'half'
        },
        
      ],
      selectionConfig: {
        targetField: 'stockGroupId',
        valueField: 'id',
        labelField: 'code'
      },
      showMoreDetails: false
    };
  }
}
